var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8054\u7CFB\u7535\u8BDD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u53CD\\u9988\\u4FE1\\u606F\\u72B6\\u60012",
    transform: "translate(-77.000000, -1506.000000)",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(77.000000, 1478.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8054\\u7CFB\\u7535\\u8BDD",
    transform: "translate(0.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9905159,13.7807128 L28.3021761,23.968235 C29.0487311,24.7058025 29.0982237,25.8949644 28.4155393,26.6920165 L27.0855702,28.2447907 C25.3160054,30.3108045 24.8186814,33.1794309 25.7895209,35.7205415 C26.7265057,38.1730275 28.0057418,40.1760016 29.6272293,41.7294636 C33.4119647,45.3554199 37.5297678,46.3033904 40.5229398,46.3033904 C42.0010133,46.3033904 43.3450659,45.4668649 44.5550977,43.7938137 C45.1997754,42.896892 46.4498641,42.6947294 47.3455855,43.3410707 C47.4324873,43.4037779 47.5142085,43.4733682 47.5907116,43.5484182 L57.1454136,53.1280398 C57.8685182,53.8525672 57.9272811,55.0061632 57.2813709,55.8002793 C54.8911387,58.7363266 52.7581985,60.5510684 50.8825504,61.2445049 C47.6400119,62.4432876 31.6407768,61.2467119 20.5502561,47.5794042 C9.45973534,33.9120965 8.703774,24.7426861 9.81496065,20.9020641 C10.459174,18.6754536 12.2822185,16.2719828 15.2840943,13.6916518 C16.0709503,13.0102702 17.2487476,13.050514 17.9905159,13.7807128 Z",
    id: "\\u8DEF\\u5F84-2",
    stroke: "#33395F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1678096,21.0687803 C40.9593439,20.7815187 44.3476422,21.8945011 47.3327045,24.4077276 C50.3177668,26.9209541 51.9163401,29.8994195 52.1284243,33.343124",
    id: "\\u8DEF\\u5F84-221",
    stroke: "#00A1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1678096,28.3361063 C39.1307646,28.187385 40.8849561,28.7635988 42.430384,30.0647477 C43.9758119,31.3658965 44.803426,32.9079091 44.9132264,34.6907855",
    id: "\\u8DEF\\u5F84-221\\u5907\\u4EFD-2",
    stroke: "#00A1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0788899,12.8691099 C44.6892927,12.9532222 49.8794058,14.7547719 53.6492294,18.273759 C57.4190529,21.7927461 59.759443,26.5346032 60.6703997,32.4993304",
    id: "\\u8DEF\\u5F84-221\\u5907\\u4EFD",
    stroke: "#00A1F0"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0b40eceab501aad81e0ef7390a7c834b.svg";
export { ForwardRef as ReactComponent };